import { QuestionnaireIcon } from "@xola/icons";
import React from "react";
import { ProductObject } from "types";
import { GlobalQuestionnaire } from "../../Questionnaire/GlobalQuestionnaire";

export const useMembershipGlobalSettingTabs = () => {
    const tabs = [
        {
            id: "questionnaire",
            label: "Questionnaire",
            icon: <QuestionnaireIcon size="large" />,
            description: "Collect additional information from your customers",
            content: <GlobalQuestionnaire productObject={ProductObject.MEMBERSHIP} />,
        },
    ];

    return tabs;
};
